import Vue from 'vue'
import env from '@/.env.js'
import session from '@/services/authentication/session'

const BACKEND_API_V1_URL = env.endpoint_backend

let isRefreshing = false
let failedQueue = []

/**
 * Method to process all the failed requests on the failedQueue
 * @param {*} error The request exception error
 */
const processQueue = (error) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error)
        } else {
            prom.resolve()
        }
    })

    failedQueue = []
}

const refreshInterceptor = {
    type: 'response',

    exception (error) {
        
        if (!shouldIntercept(error)) {
            return Promise.reject(error)
        }

        if (error.config._retry || error.config._queued) {
            return Promise.reject(error)
        }

        const originalRequest = error.config
        if (isRefreshing) {
            return new Promise(function (resolve, reject) {
                failedQueue.push({resolve, reject})
            }).then(function() {
                originalRequest._queued = true
                attachTokenToRequest(originalRequest)
                return Vue.axios.request(originalRequest)
            }).catch(function() {
                return Promise.reject(error) // Ignore refresh token request's "err" and return actual "error" for the original request
            })
        }

        originalRequest._retry = true
        isRefreshing = true
        return new Promise((resolve, reject) => {
            handleTokenRefresh.call(handleTokenRefresh)
                .then(async (tokenData) => {
                    await setTokenData(tokenData)
                    attachTokenToRequest(originalRequest)
                    processQueue(null)
                    resolve(Vue.axios.request(originalRequest))
                })
                .catch((err) => {
                    processQueue(err)
                    reject(err)
                })
                .finally(() => {
                    isRefreshing = false
                })
        })
    }
}

/**
 * Decide if request should be intercepted or not. Set wich error codes are to be treated;
 * @param {*} error The error from the request exception
 * @returns 
 */
const shouldIntercept = (error) => {
    try {
        return error.response.status === 401
    } catch (e) {
        return false
    }
}

/**
 * Saves the token and refresh token, as well as the current user;
 * @param {*} data The array containing data to be saved;
 */
const setTokenData = async (data = {}) => {
    let aux = [data.data[0].user]
    aux[0].token = data.data[0].token
    aux[0].refreshToken = data.data[0].refreshToken

    await session.saveSession(aux)
}

/**
 * Makes the refresh token request
 * @returns 
 */
const handleTokenRefresh = () => {
    return new Promise((resolve, reject) => {
        Vue.axios.post(`${BACKEND_API_V1_URL}/users/refresh-token`)
            .then(({data}) => {
                resolve(data)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

/**
 * Attaches the current token to the @request
 * @param {*} request The request to update
 */
const attachTokenToRequest = (request) => {
    request.headers['Authorization'] = 'Bearer ' + session.getToken()
}

export { refreshInterceptor }
